goog.provide('el8.appchart.dialog.ordermed.newMed');

goog.require('el8.template.appchart.dialog.ordermed.newMed');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');


el8.appchart.dialog.ordermed.newMed = (function() {

    var saveFn = null;
    var cancelFn = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Create New Medication',
        width: 400,
        height: 200,
        modal: true,
        contentFn: function() {
            return el8.template.appchart.dialog.ordermed.newMed.content();
        }
    });
    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'brandName',
                selector: ':input[name="brandName"]',
                maxLength: 100,
                infoText: 'medication name...'
            },
            {
                name: 'strength',
                selector: ':input[name="strength"]',
                maxLength: 50,
                infoText: 'strength...'
            },
            {
                name: 'medType',
                type: 'radio',
                selector: ':input[name="medType"]',
                defaultVal: 'prescription'
            }
        ]
    });
    form.addButton('ok-btn', 'Create Medication', function() {
        saveFn();
    }, true);
    form.addButton('cancel-btn', 'Discard', function() {
        cancelFn();
    });
    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec, saveCallbackFn, cancelCallbackFn) {
        super_show.call(that);
        spec = spec || {};
        saveFn = function() {
            var newMedSpec = form.getMapped();
            if (saveCallbackFn) {
                saveCallbackFn(newMedSpec);
            }
            that.hide();
        };
        cancelFn = function() {
            if (cancelCallbackFn) {
                cancelCallbackFn();
            }
            that.hide();
        };
        form.populate({
            brandName: (spec.brandName || '').trim(),
            strength: (spec.strength || '').trim()
        });
        var saveBtnCaption = spec.saveBtnCaption || 'Create Medication & Continue Rx';
        form.getButtonSet().updateButtonCaption('ok-btn', saveBtnCaption);
    };

    return that;

})();


